import React, { useState, useEffect } from "react";
import {
  BiAddToQueue,
  BiLink,
  BiListCheck,
  BiSave,
  BiTaskX,
  BiTrash,
  BiTrashAlt,
  BiX,
} from "react-icons/bi";
import {
  Modal,
  ModalHeader,
  Row,
  Col,
  Button,
  ModalBody,
  Input,
  Label,
  Alert,
  Table,
} from "reactstrap";
import { toastContainer } from "../../../utils/toast";
import "./enterprise-setting.css";
import moment from "moment";

export default function EmailDomainsPopup({
  open,
  onClose,
  allowedDomains,
  addApi,
  removeDomain,
}) {
  const [selectedTab, setSelectedTab] = useState(open || 2);
  const [emailDomain, setEmailDomain] = useState("");
  const [errors, setErrors] = useState("");

  const [domains, setDomains] = useState([]);
  const [searchInput, setSearchInput] = useState("");

  useEffect(() => {
    setDomains([...allowedDomains]);
    setSearchInput("");
  }, [allowedDomains]);

  const handleChange = (e, key) => {
    setEmailDomain(e.target.value.trim());
  };

  const validateError = () => {
    if (emailDomain) {
      if (emailDomain.replace(/\s/g, "").length === 0) {
        setErrors("Invalid email domain.");
        return true;
      } else if (emailDomain.split(".").length < 2) {
        setErrors("Invalid email domain.");

        return true;
      } else {
        return false;
      }
    } else {
      setErrors("Please enter email domain.");

      return true;
    }
  };

  const handleSave = () => {
    const isError = validateError();

    if (!isError) {
      const existing = allowedDomains.find((x) => x === emailDomain);

      if (existing) {
        setErrors("Data already exists , Please enter new");
      } else {
        setErrors("");
        addApi(emailDomain)
          .then((res) => {
            toastContainer(res, "success");
            setEmailDomain("");
          })
          .catch((err) => {
            toastContainer(err, "error");
          });
      }
    }
  };
  return (
    <div>
      <Modal isOpen={open == 1 || open == 2}>
        <ModalHeader className={"edit-modal-actions"}>
          <Row>
            <Col xs={10}>
              <h5 className="ml-3 mt-2">Enterprise Invite Rule</h5>
            </Col>
            <Col xs={2} className="text-right">
              <div className="pt-1 px-2">
                <Button className="p-1 mx-1" color="light">
                  <BiX size={"26px"} onClick={onClose} />
                </Button>
              </div>
            </Col>
          </Row>
        </ModalHeader>
        <ModalBody>
          <div className={`col-md-12 p-0`}>
            {selectedTab == 1 ? (
              <div className="mx-2">
                <span
                  className="wp-link-text my-2"
                  onClick={() => {
                    setSelectedTab(2);
                  }}
                >
                  See linked domains <BiLink size={"18px"} />{" "}
                </span>
                <h4 className="my-2"> Email Domains</h4>
                <div></div>
                <div className="mt-4">
                  <Label className="wp-add-popup-input-labels">
                    Email domain
                  </Label>
                  <Input
                    value={emailDomain}
                    onChange={(e) => handleChange(e, "workspaceId")}
                    placeholder={"Add email domain eg - ouroffice.io"}
                  />

                  <div className={"text-danger"}>{errors}</div>
                </div>

                <div className={"text-danger mt-3"}>{errors}</div>
                <div className="wp-add-action-buttons-div">
                  <Button
                    color="secondary"
                    className="wp_add_action_clear_btn"
                    onClick={() => {
                      setEmailDomain("");
                    }}
                  >
                    Clear <BiTaskX className="ml-2" />
                  </Button>
                  <Button
                    color="primary"
                    className="wp_add_action_save_btn"
                    onClick={() => {
                      handleSave();
                    }}
                  >
                    Save <BiSave className="ml-2" />{" "}
                  </Button>
                </div>
              </div>
            ) : (
              <div className="m-1">
                <div className="">
                  <div>
                    Find linked domains below {" "}
                    <span
                      className="cursor-pointer wp-link-text"
                      onClick={() => {
                        setSelectedTab(1);
                      }}
                    >
                      Click here to link another domain
                    </span>
                  </div>

                  <div className="my-3">
                    <Input
                      className="singleTaskItemSearch"
                      placeholder="Search"
                      value={searchInput}
                      onChange={(e) => {
                        const val = e.target.value;
                        setSearchInput(val);
                        if (val) {
                          const filteredWps = allowedDomains.filter((x) =>
                            x.toLowerCase().includes(val.toLowerCase())
                          );
                          setDomains([...filteredWps]);
                        } else {
                          setDomains([...allowedDomains]);
                        }
                      }}
                    />
                  </div>
                  <Table responsive hover className="taskToolkitTable">
                    <thead>
                      <tr>
                        <th>Domain</th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody>
                      {domains.map((e, idx) => {
                        return (
                          <React.Fragment key={e}>
                            <tr className="linkedToolTable" key={e}>
                              <td>{e}</td>
                              <td>
                                {" "}
                                <BiTrash
                                  className="cursor-pointer"
                                  size={"18px"}
                                  onClick={() => removeDomain(e)}
                                />{" "}
                              </td>
                            </tr>
                          </React.Fragment>
                        );
                      })}
                    </tbody>
                  </Table>
                </div>
              </div>
            )}
          </div>
        </ModalBody>
      </Modal>
    </div>
  );
}
